// src/components/PrintButton.js;
import React from "react";
//import "bootstrap/dist/css/bootstrap.min.css";
//import './conformpage.css';

const PrintButton = ({ cms }) => {
  const handlePrint = () => {
    window.print();
  };
  return (
    <button
      className="btn btn-primary btn-lg exclude-in-print"
      onClick={handlePrint}
    >
      {cms.label_print_receipt}
    </button>
  );
};

export default PrintButton;
